/**
 * Recharts replays a series' entry animation whenever its data changes, so every refresh redrew
 * the analytics charts from zero — the most distracting part of following the chain head, and dead
 * weight on a 5,000-block window besides. Spread onto every series on those pages so an update just
 * repaints in place.
 */
export const noAnimation = { isAnimationActive: false } as const;
